var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { ATN } from "antlr4ts/atn/ATN";
import { ATNDeserializer } from "antlr4ts/atn/ATNDeserializer";
import { FailedPredicateException } from "antlr4ts/FailedPredicateException";
import { NoViableAltException } from "antlr4ts/NoViableAltException";
import { Parser } from "antlr4ts/Parser";
import { ParserRuleContext } from "antlr4ts/ParserRuleContext";
import { ParserATNSimulator } from "antlr4ts/atn/ParserATNSimulator";
import { RecognitionException } from "antlr4ts/RecognitionException";
import { Token } from "antlr4ts/Token";
import { VocabularyImpl } from "antlr4ts/VocabularyImpl";
import * as Utils from "antlr4ts/misc/Utils";
const _FilterExpressionParser = class _FilterExpressionParser extends Parser {
  // @Override
  // @NotNull
  get vocabulary() {
    return _FilterExpressionParser.VOCABULARY;
  }
  // tslint:enable:no-trailing-whitespace
  // @Override
  get grammarFileName() {
    return "FilterExpression.g4";
  }
  // @Override
  get ruleNames() {
    return _FilterExpressionParser.ruleNames;
  }
  // @Override
  // @ts-ignore ts 4.x
  get serializedATN() {
    return _FilterExpressionParser._serializedATN;
  }
  constructor(input) {
    super(input);
    this._interp = new ParserATNSimulator(_FilterExpressionParser._ATN, this);
  }
  // @RuleVersion(0)
  filterSet() {
    let _localctx = new FilterSetContext(this._ctx, this.state);
    this.enterRule(_localctx, 0, _FilterExpressionParser.RULE_filterSet);
    let _la;
    try {
      let _alt;
      this.enterOuterAlt(_localctx, 1);
      {
        this.state = 10;
        this.filterExpr(0);
        this.state = 15;
        this._errHandler.sync(this);
        _alt = this.interpreter.adaptivePredict(this._input, 0, this._ctx);
        while (_alt !== 2 && _alt !== ATN.INVALID_ALT_NUMBER) {
          if (_alt === 1) {
            {
              {
                this.state = 11;
                this.match(_FilterExpressionParser.DELIM);
                this.state = 12;
                this.filterExpr(0);
              }
            }
          }
          this.state = 17;
          this._errHandler.sync(this);
          _alt = this.interpreter.adaptivePredict(this._input, 0, this._ctx);
        }
        this.state = 19;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        if (_la === _FilterExpressionParser.DELIM) {
          {
            this.state = 18;
            this.match(_FilterExpressionParser.DELIM);
          }
        }
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        _localctx.exception = re;
        this._errHandler.reportError(this, re);
        this._errHandler.recover(this, re);
      } else {
        throw re;
      }
    } finally {
      this.exitRule();
    }
    return _localctx;
  }
  // @RuleVersion(0)
  filterExpr(_p) {
    if (_p === void 0) {
      _p = 0;
    }
    let _parentctx = this._ctx;
    let _parentState = this.state;
    let _localctx = new FilterExprContext(this._ctx, _parentState);
    let _prevctx = _localctx;
    let _startState = 2;
    this.enterRecursionRule(_localctx, 2, _FilterExpressionParser.RULE_filterExpr, _p);
    try {
      let _alt;
      this.enterOuterAlt(_localctx, 1);
      {
        this.state = 27;
        this._errHandler.sync(this);
        switch (this._input.LA(1)) {
          case _FilterExpressionParser.T__0:
            {
              _localctx = new FilterGroupContext(_localctx);
              this._ctx = _localctx;
              _prevctx = _localctx;
              this.state = 22;
              this.match(_FilterExpressionParser.T__0);
              this.state = 23;
              this.filterExpr(0);
              this.state = 24;
              this.match(_FilterExpressionParser.T__1);
            }
            break;
          case _FilterExpressionParser.VARIANT:
            {
              _localctx = new FilterExprBaseContext(_localctx);
              this._ctx = _localctx;
              _prevctx = _localctx;
              this.state = 26;
              this.filterCondition();
            }
            break;
          default:
            throw new NoViableAltException(this);
        }
        this._ctx._stop = this._input.tryLT(-1);
        this.state = 37;
        this._errHandler.sync(this);
        _alt = this.interpreter.adaptivePredict(this._input, 4, this._ctx);
        while (_alt !== 2 && _alt !== ATN.INVALID_ALT_NUMBER) {
          if (_alt === 1) {
            if (this._parseListeners != null) {
              this.triggerExitRuleEvent();
            }
            _prevctx = _localctx;
            {
              this.state = 35;
              this._errHandler.sync(this);
              switch (this.interpreter.adaptivePredict(this._input, 3, this._ctx)) {
                case 1:
                  {
                    _localctx = new FilterConjunctionContext(new FilterExprContext(_parentctx, _parentState));
                    this.pushNewRecursionContext(_localctx, _startState, _FilterExpressionParser.RULE_filterExpr);
                    this.state = 29;
                    if (!this.precpred(this._ctx, 4)) {
                      throw new FailedPredicateException(this, "this.precpred(this._ctx, 4)");
                    }
                    this.state = 30;
                    this.match(_FilterExpressionParser.AND);
                    this.state = 31;
                    this.filterExpr(5);
                  }
                  break;
                case 2:
                  {
                    _localctx = new FilterDisjunctionContext(new FilterExprContext(_parentctx, _parentState));
                    this.pushNewRecursionContext(_localctx, _startState, _FilterExpressionParser.RULE_filterExpr);
                    this.state = 32;
                    if (!this.precpred(this._ctx, 3)) {
                      throw new FailedPredicateException(this, "this.precpred(this._ctx, 3)");
                    }
                    this.state = 33;
                    this.match(_FilterExpressionParser.OR);
                    this.state = 34;
                    this.filterExpr(4);
                  }
                  break;
              }
            }
          }
          this.state = 39;
          this._errHandler.sync(this);
          _alt = this.interpreter.adaptivePredict(this._input, 4, this._ctx);
        }
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        _localctx.exception = re;
        this._errHandler.reportError(this, re);
        this._errHandler.recover(this, re);
      } else {
        throw re;
      }
    } finally {
      this.unrollRecursionContexts(_parentctx);
    }
    return _localctx;
  }
  // @RuleVersion(0)
  filterCondition() {
    let _localctx = new FilterConditionContext(this._ctx, this.state);
    this.enterRule(_localctx, 4, _FilterExpressionParser.RULE_filterCondition);
    let _la;
    try {
      this.state = 52;
      this._errHandler.sync(this);
      switch (this.interpreter.adaptivePredict(this._input, 5, this._ctx)) {
        case 1:
          _localctx = new FilterBinaryContext(_localctx);
          this.enterOuterAlt(_localctx, 1);
          {
            this.state = 40;
            this.match(_FilterExpressionParser.VARIANT);
            this.state = 41;
            _localctx._op = this._input.LT(1);
            _la = this._input.LA(1);
            if (!((_la & ~31) === 0 && (1 << _la & (1 << _FilterExpressionParser.EQ | 1 << _FilterExpressionParser.NE | 1 << _FilterExpressionParser.LE | 1 << _FilterExpressionParser.LT | 1 << _FilterExpressionParser.GE | 1 << _FilterExpressionParser.GT)) !== 0)) {
              _localctx._op = this._errHandler.recoverInline(this);
            } else {
              if (this._input.LA(1) === Token.EOF) {
                this.matchedEOF = true;
              }
              this._errHandler.reportMatch(this);
              this.consume();
            }
            this.state = 42;
            this.literal();
          }
          break;
        case 2:
          _localctx = new FilterInContext(_localctx);
          this.enterOuterAlt(_localctx, 2);
          {
            this.state = 43;
            this.match(_FilterExpressionParser.VARIANT);
            this.state = 44;
            _localctx._op = this._input.LT(1);
            _la = this._input.LA(1);
            if (!(_la === _FilterExpressionParser.IN || _la === _FilterExpressionParser.NOTIN)) {
              _localctx._op = this._errHandler.recoverInline(this);
            } else {
              if (this._input.LA(1) === Token.EOF) {
                this.matchedEOF = true;
              }
              this._errHandler.reportMatch(this);
              this.consume();
            }
            this.state = 45;
            this.literalList();
          }
          break;
        case 3:
          _localctx = new FilterBetweenContext(_localctx);
          this.enterOuterAlt(_localctx, 3);
          {
            this.state = 46;
            this.match(_FilterExpressionParser.VARIANT);
            this.state = 47;
            this.match(_FilterExpressionParser.BETWEEN);
            this.state = 48;
            this.literal();
            this.state = 49;
            this.match(_FilterExpressionParser.AND);
            this.state = 50;
            this.literal();
          }
          break;
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        _localctx.exception = re;
        this._errHandler.reportError(this, re);
        this._errHandler.recover(this, re);
      } else {
        throw re;
      }
    } finally {
      this.exitRule();
    }
    return _localctx;
  }
  // @RuleVersion(0)
  literalList() {
    let _localctx = new LiteralListContext(this._ctx, this.state);
    this.enterRule(_localctx, 6, _FilterExpressionParser.RULE_literalList);
    let _la;
    try {
      this.enterOuterAlt(_localctx, 1);
      {
        this.state = 54;
        this.match(_FilterExpressionParser.T__0);
        this.state = 55;
        this.literal();
        this.state = 60;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        while (_la === _FilterExpressionParser.T__2) {
          {
            {
              this.state = 56;
              this.match(_FilterExpressionParser.T__2);
              this.state = 57;
              this.literal();
            }
          }
          this.state = 62;
          this._errHandler.sync(this);
          _la = this._input.LA(1);
        }
        this.state = 63;
        this.match(_FilterExpressionParser.T__1);
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        _localctx.exception = re;
        this._errHandler.reportError(this, re);
        this._errHandler.recover(this, re);
      } else {
        throw re;
      }
    } finally {
      this.exitRule();
    }
    return _localctx;
  }
  // @RuleVersion(0)
  literal() {
    let _localctx = new LiteralContext(this._ctx, this.state);
    this.enterRule(_localctx, 8, _FilterExpressionParser.RULE_literal);
    let _la;
    try {
      this.enterOuterAlt(_localctx, 1);
      {
        this.state = 65;
        _la = this._input.LA(1);
        if (!((_la & ~31) === 0 && (1 << _la & (1 << _FilterExpressionParser.BOOL_TRUE | 1 << _FilterExpressionParser.BOOL_FALSE | 1 << _FilterExpressionParser.STRING | 1 << _FilterExpressionParser.VERSION | 1 << _FilterExpressionParser.INTEGER)) !== 0)) {
          this._errHandler.recoverInline(this);
        } else {
          if (this._input.LA(1) === Token.EOF) {
            this.matchedEOF = true;
          }
          this._errHandler.reportMatch(this);
          this.consume();
        }
      }
    } catch (re) {
      if (re instanceof RecognitionException) {
        _localctx.exception = re;
        this._errHandler.reportError(this, re);
        this._errHandler.recover(this, re);
      } else {
        throw re;
      }
    } finally {
      this.exitRule();
    }
    return _localctx;
  }
  sempred(_localctx, ruleIndex, predIndex) {
    switch (ruleIndex) {
      case 1:
        return this.filterExpr_sempred(_localctx, predIndex);
    }
    return true;
  }
  filterExpr_sempred(_localctx, predIndex) {
    switch (predIndex) {
      case 0:
        return this.precpred(this._ctx, 4);
      case 1:
        return this.precpred(this._ctx, 3);
    }
    return true;
  }
  static get _ATN() {
    if (!_FilterExpressionParser.__ATN) {
      _FilterExpressionParser.__ATN = new ATNDeserializer().deserialize(Utils.toCharArray(_FilterExpressionParser._serializedATN));
    }
    return _FilterExpressionParser.__ATN;
  }
};
__publicField(_FilterExpressionParser, "T__0", 1);
__publicField(_FilterExpressionParser, "T__1", 2);
__publicField(_FilterExpressionParser, "T__2", 3);
__publicField(_FilterExpressionParser, "EQ", 4);
__publicField(_FilterExpressionParser, "IN", 5);
__publicField(_FilterExpressionParser, "NOTIN", 6);
__publicField(_FilterExpressionParser, "NE", 7);
__publicField(_FilterExpressionParser, "LE", 8);
__publicField(_FilterExpressionParser, "LT", 9);
__publicField(_FilterExpressionParser, "GE", 10);
__publicField(_FilterExpressionParser, "GT", 11);
__publicField(_FilterExpressionParser, "AND", 12);
__publicField(_FilterExpressionParser, "OR", 13);
__publicField(_FilterExpressionParser, "BETWEEN", 14);
__publicField(_FilterExpressionParser, "BOOL_TRUE", 15);
__publicField(_FilterExpressionParser, "BOOL_FALSE", 16);
__publicField(_FilterExpressionParser, "DELIM", 17);
__publicField(_FilterExpressionParser, "VARIANT", 18);
__publicField(_FilterExpressionParser, "STRING", 19);
__publicField(_FilterExpressionParser, "VERSION", 20);
__publicField(_FilterExpressionParser, "INTEGER", 21);
__publicField(_FilterExpressionParser, "WHITESPACE", 22);
__publicField(_FilterExpressionParser, "RULE_filterSet", 0);
__publicField(_FilterExpressionParser, "RULE_filterExpr", 1);
__publicField(_FilterExpressionParser, "RULE_filterCondition", 2);
__publicField(_FilterExpressionParser, "RULE_literalList", 3);
__publicField(_FilterExpressionParser, "RULE_literal", 4);
// tslint:disable:no-trailing-whitespace
__publicField(_FilterExpressionParser, "ruleNames", ["filterSet", "filterExpr", "filterCondition", "literalList", "literal"]);
__publicField(_FilterExpressionParser, "_LITERAL_NAMES", [
  void 0,
  "'('",
  "')'",
  "','",
  "'=='",
  void 0,
  void 0,
  void 0,
  "'<='",
  "'<'",
  "'>='",
  "'>'"
]);
__publicField(_FilterExpressionParser, "_SYMBOLIC_NAMES", [
  void 0,
  void 0,
  void 0,
  void 0,
  "EQ",
  "IN",
  "NOTIN",
  "NE",
  "LE",
  "LT",
  "GE",
  "GT",
  "AND",
  "OR",
  "BETWEEN",
  "BOOL_TRUE",
  "BOOL_FALSE",
  "DELIM",
  "VARIANT",
  "STRING",
  "VERSION",
  "INTEGER",
  "WHITESPACE"
]);
__publicField(_FilterExpressionParser, "VOCABULARY", new VocabularyImpl(
  _FilterExpressionParser._LITERAL_NAMES,
  _FilterExpressionParser._SYMBOLIC_NAMES,
  []
));
__publicField(_FilterExpressionParser, "_serializedATN", `줝쪺֍꾺体؇쉁F					\x07
\f\v

\x07&
\f)\v7
\x07=
\f@\v\x07\b
	\r\x07\bH\f6\b8
C\f\r\x07\r\x07\b\x07\x1B\x07\x1B' \f !\x07!&\x07"#\f#$\x07$&%%"&)'%'(()'*+\x07+,	,7
-.\x07./	/7\b01\x0712\x0723
34\x0745
576*6-607\x0789\x079>
:;\x07;=
<:=@><>??A@>AB\x07B	CD	D\v	%'6>`);
__publicField(_FilterExpressionParser, "__ATN");
let FilterExpressionParser = _FilterExpressionParser;
class FilterSetContext extends ParserRuleContext {
  filterExpr(i) {
    if (i === void 0) {
      return this.getRuleContexts(FilterExprContext);
    } else {
      return this.getRuleContext(i, FilterExprContext);
    }
  }
  DELIM(i) {
    if (i === void 0) {
      return this.getTokens(FilterExpressionParser.DELIM);
    } else {
      return this.getToken(FilterExpressionParser.DELIM, i);
    }
  }
  constructor(parent, invokingState) {
    super(parent, invokingState);
  }
  // @Override
  // @ts-ignore ts 4.x
  get ruleIndex() {
    return FilterExpressionParser.RULE_filterSet;
  }
  // @Override
  enterRule(listener) {
    if (listener.enterFilterSet) {
      listener.enterFilterSet(this);
    }
  }
  // @Override
  exitRule(listener) {
    if (listener.exitFilterSet) {
      listener.exitFilterSet(this);
    }
  }
  // @Override
  accept(visitor) {
    if (visitor.visitFilterSet) {
      return visitor.visitFilterSet(this);
    } else {
      return visitor.visitChildren(this);
    }
  }
}
class FilterExprContext extends ParserRuleContext {
  constructor(parent, invokingState) {
    super(parent, invokingState);
  }
  // @Override
  // @ts-ignore ts 4.x
  get ruleIndex() {
    return FilterExpressionParser.RULE_filterExpr;
  }
  copyFrom(ctx) {
    super.copyFrom(ctx);
  }
}
class FilterConjunctionContext extends FilterExprContext {
  filterExpr(i) {
    if (i === void 0) {
      return this.getRuleContexts(FilterExprContext);
    } else {
      return this.getRuleContext(i, FilterExprContext);
    }
  }
  AND() {
    return this.getToken(FilterExpressionParser.AND, 0);
  }
  constructor(ctx) {
    super(ctx.parent, ctx.invokingState);
    this.copyFrom(ctx);
  }
  // @Override
  enterRule(listener) {
    if (listener.enterFilterConjunction) {
      listener.enterFilterConjunction(this);
    }
  }
  // @Override
  exitRule(listener) {
    if (listener.exitFilterConjunction) {
      listener.exitFilterConjunction(this);
    }
  }
  // @Override
  accept(visitor) {
    if (visitor.visitFilterConjunction) {
      return visitor.visitFilterConjunction(this);
    } else {
      return visitor.visitChildren(this);
    }
  }
}
class FilterDisjunctionContext extends FilterExprContext {
  filterExpr(i) {
    if (i === void 0) {
      return this.getRuleContexts(FilterExprContext);
    } else {
      return this.getRuleContext(i, FilterExprContext);
    }
  }
  OR() {
    return this.getToken(FilterExpressionParser.OR, 0);
  }
  constructor(ctx) {
    super(ctx.parent, ctx.invokingState);
    this.copyFrom(ctx);
  }
  // @Override
  enterRule(listener) {
    if (listener.enterFilterDisjunction) {
      listener.enterFilterDisjunction(this);
    }
  }
  // @Override
  exitRule(listener) {
    if (listener.exitFilterDisjunction) {
      listener.exitFilterDisjunction(this);
    }
  }
  // @Override
  accept(visitor) {
    if (visitor.visitFilterDisjunction) {
      return visitor.visitFilterDisjunction(this);
    } else {
      return visitor.visitChildren(this);
    }
  }
}
class FilterGroupContext extends FilterExprContext {
  filterExpr() {
    return this.getRuleContext(0, FilterExprContext);
  }
  constructor(ctx) {
    super(ctx.parent, ctx.invokingState);
    this.copyFrom(ctx);
  }
  // @Override
  enterRule(listener) {
    if (listener.enterFilterGroup) {
      listener.enterFilterGroup(this);
    }
  }
  // @Override
  exitRule(listener) {
    if (listener.exitFilterGroup) {
      listener.exitFilterGroup(this);
    }
  }
  // @Override
  accept(visitor) {
    if (visitor.visitFilterGroup) {
      return visitor.visitFilterGroup(this);
    } else {
      return visitor.visitChildren(this);
    }
  }
}
class FilterExprBaseContext extends FilterExprContext {
  filterCondition() {
    return this.getRuleContext(0, FilterConditionContext);
  }
  constructor(ctx) {
    super(ctx.parent, ctx.invokingState);
    this.copyFrom(ctx);
  }
  // @Override
  enterRule(listener) {
    if (listener.enterFilterExprBase) {
      listener.enterFilterExprBase(this);
    }
  }
  // @Override
  exitRule(listener) {
    if (listener.exitFilterExprBase) {
      listener.exitFilterExprBase(this);
    }
  }
  // @Override
  accept(visitor) {
    if (visitor.visitFilterExprBase) {
      return visitor.visitFilterExprBase(this);
    } else {
      return visitor.visitChildren(this);
    }
  }
}
class FilterConditionContext extends ParserRuleContext {
  constructor(parent, invokingState) {
    super(parent, invokingState);
  }
  // @Override
  // @ts-ignore ts 4.x
  get ruleIndex() {
    return FilterExpressionParser.RULE_filterCondition;
  }
  copyFrom(ctx) {
    super.copyFrom(ctx);
  }
}
class FilterBinaryContext extends FilterConditionContext {
  constructor(ctx) {
    super(ctx.parent, ctx.invokingState);
    __publicField(this, "_op");
    this.copyFrom(ctx);
  }
  VARIANT() {
    return this.getToken(FilterExpressionParser.VARIANT, 0);
  }
  literal() {
    return this.getRuleContext(0, LiteralContext);
  }
  EQ() {
    return this.tryGetToken(FilterExpressionParser.EQ, 0);
  }
  NE() {
    return this.tryGetToken(FilterExpressionParser.NE, 0);
  }
  LE() {
    return this.tryGetToken(FilterExpressionParser.LE, 0);
  }
  LT() {
    return this.tryGetToken(FilterExpressionParser.LT, 0);
  }
  GE() {
    return this.tryGetToken(FilterExpressionParser.GE, 0);
  }
  GT() {
    return this.tryGetToken(FilterExpressionParser.GT, 0);
  }
  // @Override
  enterRule(listener) {
    if (listener.enterFilterBinary) {
      listener.enterFilterBinary(this);
    }
  }
  // @Override
  exitRule(listener) {
    if (listener.exitFilterBinary) {
      listener.exitFilterBinary(this);
    }
  }
  // @Override
  accept(visitor) {
    if (visitor.visitFilterBinary) {
      return visitor.visitFilterBinary(this);
    } else {
      return visitor.visitChildren(this);
    }
  }
}
class FilterInContext extends FilterConditionContext {
  constructor(ctx) {
    super(ctx.parent, ctx.invokingState);
    __publicField(this, "_op");
    this.copyFrom(ctx);
  }
  VARIANT() {
    return this.getToken(FilterExpressionParser.VARIANT, 0);
  }
  literalList() {
    return this.getRuleContext(0, LiteralListContext);
  }
  IN() {
    return this.tryGetToken(FilterExpressionParser.IN, 0);
  }
  NOTIN() {
    return this.tryGetToken(FilterExpressionParser.NOTIN, 0);
  }
  // @Override
  enterRule(listener) {
    if (listener.enterFilterIn) {
      listener.enterFilterIn(this);
    }
  }
  // @Override
  exitRule(listener) {
    if (listener.exitFilterIn) {
      listener.exitFilterIn(this);
    }
  }
  // @Override
  accept(visitor) {
    if (visitor.visitFilterIn) {
      return visitor.visitFilterIn(this);
    } else {
      return visitor.visitChildren(this);
    }
  }
}
class FilterBetweenContext extends FilterConditionContext {
  VARIANT() {
    return this.getToken(FilterExpressionParser.VARIANT, 0);
  }
  BETWEEN() {
    return this.getToken(FilterExpressionParser.BETWEEN, 0);
  }
  literal(i) {
    if (i === void 0) {
      return this.getRuleContexts(LiteralContext);
    } else {
      return this.getRuleContext(i, LiteralContext);
    }
  }
  AND() {
    return this.getToken(FilterExpressionParser.AND, 0);
  }
  constructor(ctx) {
    super(ctx.parent, ctx.invokingState);
    this.copyFrom(ctx);
  }
  // @Override
  enterRule(listener) {
    if (listener.enterFilterBetween) {
      listener.enterFilterBetween(this);
    }
  }
  // @Override
  exitRule(listener) {
    if (listener.exitFilterBetween) {
      listener.exitFilterBetween(this);
    }
  }
  // @Override
  accept(visitor) {
    if (visitor.visitFilterBetween) {
      return visitor.visitFilterBetween(this);
    } else {
      return visitor.visitChildren(this);
    }
  }
}
class LiteralListContext extends ParserRuleContext {
  literal(i) {
    if (i === void 0) {
      return this.getRuleContexts(LiteralContext);
    } else {
      return this.getRuleContext(i, LiteralContext);
    }
  }
  constructor(parent, invokingState) {
    super(parent, invokingState);
  }
  // @Override
  // @ts-ignore ts 4.x
  get ruleIndex() {
    return FilterExpressionParser.RULE_literalList;
  }
  // @Override
  enterRule(listener) {
    if (listener.enterLiteralList) {
      listener.enterLiteralList(this);
    }
  }
  // @Override
  exitRule(listener) {
    if (listener.exitLiteralList) {
      listener.exitLiteralList(this);
    }
  }
  // @Override
  accept(visitor) {
    if (visitor.visitLiteralList) {
      return visitor.visitLiteralList(this);
    } else {
      return visitor.visitChildren(this);
    }
  }
}
class LiteralContext extends ParserRuleContext {
  VERSION() {
    return this.tryGetToken(FilterExpressionParser.VERSION, 0);
  }
  STRING() {
    return this.tryGetToken(FilterExpressionParser.STRING, 0);
  }
  INTEGER() {
    return this.tryGetToken(FilterExpressionParser.INTEGER, 0);
  }
  BOOL_TRUE() {
    return this.tryGetToken(FilterExpressionParser.BOOL_TRUE, 0);
  }
  BOOL_FALSE() {
    return this.tryGetToken(FilterExpressionParser.BOOL_FALSE, 0);
  }
  constructor(parent, invokingState) {
    super(parent, invokingState);
  }
  // @Override
  // @ts-ignore ts 4.x
  get ruleIndex() {
    return FilterExpressionParser.RULE_literal;
  }
  // @Override
  enterRule(listener) {
    if (listener.enterLiteral) {
      listener.enterLiteral(this);
    }
  }
  // @Override
  exitRule(listener) {
    if (listener.exitLiteral) {
      listener.exitLiteral(this);
    }
  }
  // @Override
  accept(visitor) {
    if (visitor.visitLiteral) {
      return visitor.visitLiteral(this);
    } else {
      return visitor.visitChildren(this);
    }
  }
}
export {
  FilterBetweenContext,
  FilterBinaryContext,
  FilterConditionContext,
  FilterConjunctionContext,
  FilterDisjunctionContext,
  FilterExprBaseContext,
  FilterExprContext,
  FilterExpressionParser,
  FilterGroupContext,
  FilterInContext,
  FilterSetContext,
  LiteralContext,
  LiteralListContext
};
//# sourceMappingURL=FilterExpressionParser.js.map
